import {useState, useContext} from "react";
import client from "../client/api";
import CONSTANTS from "../constants/index";

import buildForm from './buildForm'
import history from '../routes/helper/history'
import parseErrorClient from "../utils/parseErrorClient";
import {GlobalMessageContext} from "../context/GlobalMessage";
import useQuery from "../routes/helper/useQueryHooks";

const RegisterHook = () => {
    const {setNotification} = useContext(GlobalMessageContext)
    const [success, setSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const target = useQuery().get("target") || CONSTANTS.APP.PROFILE
    const redirectLogin = () => history.push(`/?target=${target}`)
    const handleRegister = async event => {
        event.preventDefault();


        try {

            if (!loading)  {
                setLoading("aguarde...")
                await client.post(CONSTANTS.API.REGISTRO, buildForm(event.target))
            }
            setSuccess(true)
            setLoading(false)

        } catch (error) {
            setNotification(parseErrorClient(error, setLoading))
        }

    }

    return {
        handleRegister,
        redirectLogin,
        success,
        loading
    };
};

export default RegisterHook;
